<h1 *ngIf="!data.Mobile" matDialogTitle class="dialog-title">{{data.Title}}</h1>
<h2 *ngIf="data.Mobile" matDialogTitle class="dialog-title">{{data.Title}}</h2>
  
<div class="dialog-content" [ngStyle]="{'font-size': !data.Mobile ? '21px' : '19px' }" matDialogContent>
  <p>{{data.Description}}</p>
</div>
<hr class="mat-dialog-separator" style="width:100%;text-align:left;margin-left:0;border-color:#fff;">
<div matDialogActions class="dialog-buttons d-flex justify-content-end">
  <button class="btn btn-flat" mat-button (click)="onClose()">Got it</button>
</div>